import React from 'react';
import { connect } from 'react-redux';

import { withRouter } from 'react-router-dom';
import { selectActiveWorkspace } from 'js/store/reducers/workspaces';
import WorkspaceSettings from '../components/WorkspaceSetttings';

function WorkspaceSettingsContainer({ activeWorkspace }) {
  return <WorkspaceSettings workspace={activeWorkspace} />;
}

export default withRouter(
  connect((store) => ({
    activeWorkspace: selectActiveWorkspace(store),
  }))(WorkspaceSettingsContainer)
);
